import React from 'react';
import PropTypes from 'prop-types';

import settingsReader from '../../store/readHelpers/SettingsReader';
import { t } from '../../services/i18nService';
import AdditionalResource from './AdditionalResource';
import constants from '../../qti/Constants';
import RubricAdditionalResourceSelector from '../../selectors/rubrics/RubricAdditionalResourceSelector';

const RubricAdditionalResource = (props) => {
    const { currentlyShownQuestion } = props;
    const { rubricsContentItemId, rubricsContentRevisionId } = currentlyShownQuestion;

    const rubricsUrl = RubricAdditionalResourceSelector.selectRubricsUrl(rubricsContentItemId, rubricsContentRevisionId);

    let linkText = t('general.rubric');
    if (settingsReader.isShowQuestionTitlesEnabled()) {
        linkText = `${linkText} ${t('general.for')} ${currentlyShownQuestion.title}`;
    }

    return <AdditionalResource url={rubricsUrl} title={linkText} type={constants.additionalResourceType.RUBRIC} />;
};

RubricAdditionalResource.propTypes = {
    currentlyShownQuestion: PropTypes.object.isRequired,
};

export default RubricAdditionalResource;
